import React from "react";
import logoFiles from "../data/brandLogoFiles.json";

// Logo files are copied into public/images/brands at build time
// (scripts/fetch-brand-logos.mjs), which also records each logo's width/height
// ratio. Logos are sized so they carry similar visual weight: wide logos get
// shorter, square ones taller, around the row height set by --logo-h.
const REF_RATIO = 1.6;

const BrandLogo = ({ brand }) => {
  const entry = logoFiles[brand.file];
  const file = typeof entry === "string" ? entry : entry?.file;
  const ratio = typeof entry === "object" ? entry.ratio : undefined;

  if (!file) {
    return (
      <span className="font-heading text-base lg:text-lg uppercase tracking-wide text-ink/70 text-center leading-tight">
        {brand.name}
      </span>
    );
  }

  const scale = ratio ? Math.min(1.25, Math.max(0.62, Math.sqrt(REF_RATIO / ratio))) : 1;
  return (
    <img
      src={`/images/brands/${file}`}
      alt={brand.name}
      title={brand.name}
      loading="lazy"
      width={ratio ? Math.round(100 * ratio) : undefined}
      height={ratio ? 100 : undefined}
      style={{ height: `calc(var(--logo-h) * ${scale.toFixed(3)})` }}
      className="w-auto max-w-full object-contain"
    />
  );
};

export default BrandLogo;
